export function OnboardingHeader() {
  return (
    <header className="flex h-16 items-center border-b bg-background px-4 lg:px-6">
      <div className="flex items-center gap-2">
        <span className="text-lg font-semibold">HeaderHawk</span>
      </div>
    </header>
  );
}
